import React from 'react';

import { Switch as DefaultSwitch } from 'react-router-dom';

const Switch: React.FC = props => <DefaultSwitch {...props} />;

export default Switch;
